module.exports = __webpack_public_path__ + "static/media/speaker-zhiqiang.00bab024.jpg";